var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "980.000000pt",
    height: "983.000000pt",
    viewBox: "0 0 980.000000 983.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,983.000000) scale(0.100000,-0.100000)",
    fill: "#d3d3d3",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3310 9814 c-19 -2 -84 -9 -144 -14 -404 -39 -830 -166 -1217 -361 -1447 -731 -2217 -2357 -1863 -3937 145 -647 446 -1205 920 -1703 217 -228 359 -350 564 -486 538 -357 1202 -546 1920 -546 619 0 1164 123 1699 384 l184 90 1541 -1539 c975 -974 1565 -1556 1606 -1584 131 -91 228 -123 350 -115 176 12 310 96 566 351 251 252 331 375 357 554 19 126 -19 258 -110 386 -20 28 -728 744 -1574 1591 l-1537 1540 50 85 c230 389 386 865 450 1370 20 161 17 681 -5 840 -111 795 -440 1475 -981 2029 -576 589 -1280 938 -2111 1047 -113 15 -582 28 -665 18z m560 -1215 c764 -108 1414 -584 1756 -1284 242 -497 298 -1064 159 -1607 -52 -201 -161 -456 -273 -636 -497 -800 -1439 -1224 -2366 -1066 -537 92 -1040 379 -1388 794 -595 709 -715 1695 -308 2526 229 467 603 837 1075 1065 425 206 872 275 1345 208z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.26fd3175f0c3a0a299b60e8ade349d64.svg";
export { ForwardRef as ReactComponent };